let id = 0
const getUniqueId = () => ++id
export { getUniqueId }
